import { useEffect, useState } from 'react'
import { Navigate } from 'react-router'
import * as routes from '../routes'
import { Login } from '../auth'
import authClient from '../auth/authClient'
import { Loading, useAdminTitle } from '../shared'

const AdminLogin = (props) => {
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    authClient.initialize(() => {
      const handler = () => { setLoading(false) }
      authClient.tryLogin(routes.adminAuthUrl).then(handler).catch(handler)
    })
  }, [])

  useAdminTitle('Sign in')

  if (loading) {
    return <Loading />
  }

  if (authClient.isLoggedIn()) {
    return <Navigate to={routes.adminSearchPath} />
  }

  const loginProps = {
    providers: ['google'],
    signInUrl: routes.adminAuthUrl,
    signUpPath: routes.adminRootPath, // there is no sign up path for admins
    afterLoginPath: routes.adminSearchPath
  }
  return <Login {...loginProps} {...props} />
}

export default AdminLogin
